import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPlus48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="plus">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 26L24 49.0415L26 49.0415L26 26H49.0416V24H26L26 0.958252H24L24 24H0.958374V26H24Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPlus24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="plus">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 12.9999L11 23.3137L13 23.3137L13 12.9999H23.3137V10.9999H13L13 0.686282L11 0.686279L11 10.9999H0.686279V12.9999H11Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPlus16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="plus">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.99993 9.00024L6.99996 15L8.99996 15L8.99993 9.00024L14.9999 9.00002V7.00002L8.99994 7.00024L8.99993 1.00001L6.99993 1L6.99994 7.00024L0.999939 7.00001V9.00002L6.99993 9.00024Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
